
import React, { useState } from 'react';
import { WebApiURL } from '../../Constants/Constants';
import ProfileManagment from "./ProfileManagment";
import Verify from "../Verify";
// import OppTab from "../OpportunitiesPage/OpportunitiesTab";
import VerifyAdminTab from "../VerificationsAdmin/VerifyAdminTab";


import { useRef } from "react";

function VerifyForm({ setActiveForm }) {
    // ---------- your existing state ----------
    const [formData, setFormData] = useState({
        certificateNumber: "",
        idNumber: "",
        passportNumber: "",
        caseStatus: "",
        certificateType: "",
        expiryDate: "",
        givenName: "",
        middleName: "",
        surname: "",
        DateOfBirth: "",
        nationality: "",
        placeOfBirth: "",
        stcwReference: "",
        stcwRegulation: "",
        certificateTitle: "",
        certificateDepartment: "",
        certificateGroup: "",
        issueDate: "",
        certificateExpiryDate: "",
        issueCertDatePerformed: "",
        interimExpiryDate: "",
        stcwIssuePlace: "",
        stcwPlaceOfExam: "",
        placeOfExam: "",
        trainingInstitution: "",
        countryOfIssue: "",
        issuingAuthority: "",
        stcwCapacityOne: "",

        stcwCapacityTwo: "",
        stcwCapacityThree: "",
        stcwCapacityFour: "",
        stcwCapacityLimitationOn: "",
        stcwCapacityLimitationTw: "",
        stcwCapacityLimitationTh: "",
        stcwCapacityLimitationFo: "",
        stcwFunctionOne: "",
        stcwFunctionTwo: "",
        stcwFunctionThree: "",
        stcwFunctionFour: "",
        stcwFunctionFive: "",
        stcwFunctionSix: "",
        stcwLevelOne: "",
        stcwLevelTwo: "",
        stcwLevelThree: "",
        stcwLevelFour: "",
        stcwLevelFive: "",
        stcwLevelSix: "",
        stcwFunctionLimitationOn: "",
        stcwFunctionLimitationTw: "",
        stcwFunctionLimitationTh: "",
        stcwFunctionLimitationFo: "",
        stcwFunctionLimitationFi: "",
        stcwFunctionLimitationSi: "",
        additionalEndorse1: "",
        additionalEndorse2: "",
        additionalEndorse3: "",
        additionalEndorse4: "",
        additionalEndorse5: "",
        additionalEndorse6: "",
        copValidUntilOne: "",
        copValidUntilTwo: "",
        copValidUntilThree: "",
        copValidUntilFour: "",
        copValidUntilFive: "",
        copValidUntilSix: "",
        copValidUntilSeven: "",
        copValidUntilEight: "",
        copValidUntilNine: "",
        copValidUntilTen: "",
        copValidUntilEleven: "",
        copValidUntilTwelve: "",
        retainOldCertificateNumber: "",
        countryOfIssueRegI10: "",
        notRobot: false
    });

    const [buttonText, setButtonText] = useState('Verify');
    const [statusMessage, setStatusMessage] = useState('');
    const [results, setResults] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const certRef = useRef();
    // ---------- added: modal state ----------
    const [details, setDetails] = useState(null); // when set, modal opens


    //pdf generation 

    const handleGeneratePDF = async () => {
        if (!details) return;

        // Get logged-in user from localStorage
        const user = JSON.parse(localStorage.getItem("user") || "{}");

        // ✅ Check for the actual property from OTP response
        if (!user?.userId) {
            alert("User not authenticated. Please verify OTP first.");
            return;
        }

        // ---------- DEBUG: log user object ----------
        console.log("User from localStorage:", user);
        console.log("UserId being sent to API:", user.userId);

        try {
            const response = await fetch(`${WebApiURL}Verification/generate-pdf`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    CertificateNumber: details.certificateNumber,
                    IdNumber: details.idNumber,
                    UserId: user.userId, // ✅ use correct property
                    FullName: user.fullName

                }),
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || 'Failed to generate PDF');
            }

            const blob = await response.blob(); // PDF file as blob
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Verification_${details.certificateNumber || 'Report'}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            alert('Error generating PDF: ' + err.message);
        }
    };


    // ---------- your handlers (unchanged) ----------
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleClear = () => {
        setFormData({
            certificateNumber: "",
            idNumber: "",
            passportNumber: "",
            caseStatus: "",
            certificateType: "",
            expiryDate: "",
            givenName: "",
            middleName: "",
            surname: "",
            DateOfBirth: "",
            nationality: "",
            placeOfBirth: "",
            stcwReference: "",
            stcwRegulation: "",
            certificateTitle: "",
            certificateDepartment: "",
            certificateGroup: "",
            issueDate: "",
            certificateExpiryDate: "",
            issueCertDatePerformed: "",
            interimExpiryDate: "",
            stcwIssuePlace: "",
            stcwPlaceOfExam: "",
            placeOfExam: "",
            trainingInstitution: "",
            countryOfIssue: "",
            issuingAuthority: "",
            stcwCapacityOne: "",
            stcwCapacityTwo: "",
            stcwCapacityThree: "",
            stcwCapacityFour: "",
            stcwCapacityLimitationOn: "",
            stcwCapacityLimitationTw: "",
            stcwCapacityLimitationTh: "",
            stcwCapacityLimitationFo: "",
            stcwFunctionOne: "",
            stcwFunctionTwo: "",
            stcwFunctionThree: "",
            stcwFunctionFour: "",
            stcwFunctionFive: "",
            stcwFunctionSix: "",
            stcwLevelOne: "",
            stcwLevelTwo: "",
            stcwLevelThree: "",
            stcwLevelFour: "",
            stcwLevelFive: "",
            stcwLevelSix: "",
            stcwFunctionLimitationOn: "",
            stcwFunctionLimitationTw: "",
            stcwFunctionLimitationTh: "",
            stcwFunctionLimitationFo: "",
            stcwFunctionLimitationFi: "",
            stcwFunctionLimitationSi: "",
            additionalEndorse1: "",
            additionalEndorse2: "",
            additionalEndorse3: "",
            additionalEndorse4: "",
            additionalEndorse5: "",
            additionalEndorse6: "",
            copValidUntilOne: "",
            copValidUntilTwo: "",
            copValidUntilThree: "",
            copValidUntilFour: "",
            copValidUntilFive: "",
            copValidUntilSix: "",
            copValidUntilSeven: "",
            copValidUntilEight: "",
            copValidUntilNine: "",
            copValidUntilTen: "",
            copValidUntilEleven: "",
            copValidUntilTwelve: "",
            retainOldCertificateNumber: "",
            countryOfIssueRegI10: "",
            notRobot: false
        });
        setResults([]);
        setStatusMessage('');
        setButtonText('Verify');
    };

    const handleVerifyButton = () => {
        if (buttonText === 'Verify') setButtonText('Submit');

    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatusMessage('');
        setResults([]);
        setIsSubmitting(true);

        const idFilled = (formData.idNumber || '').trim() !== '';
        const certFilled = (formData.certificateNumber || '').trim() !== '';

        // Validation check
        if (!idFilled && !certFilled) {
            setStatusMessage('Please enter either an ID Number OR a Certificate Number.');
            setIsSubmitting(false);
            return;
        }

        // Build request body dynamically
        const requestBody = {};
        if (idFilled) requestBody.IdNumber = formData.idNumber;
        if (certFilled) requestBody.CertificateNumber = formData.certificateNumber;

        try {
            const response = await fetch(`${WebApiURL}Verification/verify`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody)
            });

            const text = await response.text();
            let data;

            try {
                data = JSON.parse(text);
            } catch {
                setStatusMessage("Server returned invalid response format.");
                return;
            }

            if (response.ok && data.matchedRecords?.length > 0) {
                setResults(data.matchedRecords);
                setStatusMessage('Verification successful.');

                // Auto clear after 10 seconds
                setTimeout(() => setStatusMessage(''), 10000);
            } else {
                setStatusMessage(data.message || 'No matching records found.');
                setTimeout(() => setStatusMessage(''), 10000);
            }
        } catch (err) {
            setStatusMessage('Server error or network issue.');
        } finally {
            setIsSubmitting(false);
        }
    };



    // ---------- helpers to clean & map data to the template ----------
    const clean = (v) => {
        const s = (v ?? '').toString();
        return s.trim();
    };

    const isPresent = (v) => clean(v) !== '';

    const mapToCertificateView = (recInput) => {
        // Utility functions
        const clean = (v) => (v ?? '').toString().trim();
        const isPresent = (v) => clean(v) !== '';

        // Capacity, function, and endorsement details if you need them for the modal (use from API record, not formData!)
        const capacityDetailsRaw = [
            { capacity: clean(recInput.stcwCapacityOne), limitation: clean(recInput.stcwCapacityLimitationOn) },
            { capacity: clean(recInput.stcwCapacityTwo), limitation: clean(recInput.stcwCapacityLimitationTw) },
            { capacity: clean(recInput.stcwCapacityThree), limitation: clean(recInput.stcwCapacityLimitationTh) },
            { capacity: clean(recInput.stcwCapacityFour), limitation: clean(recInput.stcwCapacityLimitationFo) },
        ].filter(row => isPresent(row.capacity) || isPresent(row.limitation));

        const functionsTopRaw = [
            { func: clean(recInput.stcwFunctionOne), level: clean(recInput.stcwLevelOne), limitation: clean(recInput.stcwFunctionLimitationOn) },
            { func: clean(recInput.stcwFunctionTwo), level: clean(recInput.stcwLevelTwo), limitation: clean(recInput.stcwFunctionLimitationTw) },
            { func: clean(recInput.stcwFunctionThree), level: clean(recInput.stcwLevelThree), limitation: clean(recInput.stcwFunctionLimitationTh) },
            { func: clean(recInput.stcwFunctionFour), level: clean(recInput.stcwLevelFour), limitation: clean(recInput.stcwFunctionLimitationFo) },
        ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

        const functionsBottomRaw = [
            { func: clean(recInput.stcwFunctionFive), level: clean(recInput.stcwLevelFive), limitation: clean(recInput.stcwFunctionLimitationFi) },
            { func: clean(recInput.stcwFunctionSix), level: clean(recInput.stcwLevelSix), limitation: clean(recInput.stcwFunctionLimitationSi) },
        ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

        const endorsements = [
            recInput.additionalEndorse1,
            recInput.additionalEndorse2,
            recInput.additionalEndorse3,
            recInput.additionalEndorse4,
            recInput.additionalEndorse5,
            recInput.additionalEndorse6,
        ].map(clean).filter(isPresent);

        return {
            salutationName: 'Recipient',

            firstName: clean(recInput.givenName) || '—',
            surname: clean(recInput.surname) || '—',
            dob: clean(recInput.dateOfBirth) || '—',
            certificateNumber: clean(recInput.certificateNumber) || '—',
            stcwReference: clean(recInput.stcwReference) || clean(recInput.stcwRegulation) || '—',
            issueDate: clean(recInput.issueDate) || clean(recInput.issueCertDatePerformed) || '—',
            expiryDate: clean(recInput.certificateExpiryDate) || clean(recInput.expiryDate) || '—',
            certificateTitle: clean(recInput.certificateTitle) || '—',
            // Optional arrays
            capacityDetails: capacityDetailsRaw,
            functionsTop: functionsTopRaw,
            functionsBottom: functionsBottomRaw,
            endorsements,
        };
    };

    const openDetails = (rec) => {
        const mapped = mapToCertificateView(rec);
        setDetails(mapped);
    };

    const closeDetails = () => setDetails(null);

    // ---------- UI ----------

    return (


    //    <ProfileManagment/>
    // <OppTab />
    <VerifyAdminTab />

    //    <Verify/>
    );
}

export default VerifyForm;